import React from 'react';
import { Button } from '@mui/material';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Incident } from '../../types';
import { useChartModalState } from '../../hooks/useChartModalState';
import { historicalChartButtonStyles } from './styles';

interface HistoricalChartCellProps {
  params: GridRenderCellParams<Incident>;
}

interface HistoricalChartButtonProps {
  row: Incident;
}

const HistoricalChartButton: React.FC<HistoricalChartButtonProps> = ({
  row,
}) => {
  const { openModal } = useChartModalState();

  const handleOpenModal = () => {
    openModal(row);
  };

  return (
    <Button
      variant='outlined'
      color='primary'
      size='small'
      startIcon={<ShowChartIcon />}
      onClick={handleOpenModal}
      aria-label={`View temperature history for ${row.deviceName}`}
      sx={historicalChartButtonStyles}
    >
      History
    </Button>
  );
};

HistoricalChartButton.displayName = 'HistoricalChartButton';

const HistoricalChartCell: React.FC<HistoricalChartCellProps> = ({
  params,
}) => {
  return <HistoricalChartButton row={params.row} />;
};

HistoricalChartCell.displayName = 'HistoricalChartCell';

export default HistoricalChartCell;
